export enum PhotographySource {
  Legacy = 'legacy',
  Catalog = 'catalog',
}
